import {
  FETCH_APPLICATION_SETTINGS_FLAGS,
  FETCH_APPLICATION_SETTINGS_FLAGS_SUCCESS,
  FETCH_APPLICATION_SETTINGS_FLAGS_FAILURE,
  UPDATE_APPLICATION_SETTINGS_FLAGS,
  UPDATE_APPLICATION_SETTINGS_FLAGS_SUCCESS,
  UPDATE_APPLICATION_SETTINGS_FLAGS_FAILURE,
  CLEAR_DEV_CACHE,
  CLEAR_DEV_CACHE_SUCCESS,
  CLEAR_DEV_CACHE_FAILURE,
  MATERIALIZED_VIEW_REFRESH,
  MATERIALIZED_VIEW_REFRESH_SUCCESS,
  MATERIALIZED_VIEW_REFRESH_FAILURE,
  UNLOCK_ALL_TAX_ENTRIES,
  UNLOCK_ALL_TAX_ENTRIES_SUCCESS,
  UNLOCK_ALL_TAX_ENTRIES_FAILURE,
  FETCH_ADMIN_JOBS,
  FETCH_ADMIN_JOBS_SUCCESS,
  FETCH_ADMIN_JOBS_FAILURE,
  RUN_ADMIN_JOB,
  RUN_ADMIN_JOB_SUCCESS,
  RUN_ADMIN_JOB_FAILURE,
  RUN_DEACTIVATE_USERS_JOB,
  RUN_DEACTIVATE_USERS_JOB_SUCCESS,
  RUN_DEACTIVATE_USERS_JOB_FAILURE,
  CLEAR_BSM_BALANCES,
  CLEAR_BSM_BALANCES_SUCCESS,
  CLEAR_BSM_BALANCES_FAILURE,
  SELECT_PERIODS,
  SELECT_COMPANY_CODES,
} from './types';

import {
  fetchApplicationSettingsFlags as fetchApplicationSettingsFlagApi,
  updateApplicationSettingsFlags as updateApplicationSettingsFlagApi,
  clearDevCache as clearDevCacheApi,
  materializedViewRefresh as materializedViewRefreshApi,
  unlockAllTaxEntries as unlockAllTaxEntriesApi,
  fetchAdminJobs as fetchAdminJobsApi,
  runAdminJob as runAdminJobApi,
  runDeactivateUsersJob as runDeactivateUsersJobApi,
  clearBsmBalances as clearBsmBalancesApi,
} from '../api';
import { fetchingError } from '../../../shared/store/actions';
import { errorNotification, successNotification } from '../../../shared/store/notificationActions';

export const fetchApplicationSettingsFlags = () => async dispatch => {
  dispatch({
    type: FETCH_APPLICATION_SETTINGS_FLAGS,
  });

  try {
    const applicationSettingsFlags = await fetchApplicationSettingsFlagApi();

    return dispatch({
      type: FETCH_APPLICATION_SETTINGS_FLAGS_SUCCESS,
      applicationSettingsFlags,
    });
  } catch (error) {
    dispatch({
      type: FETCH_APPLICATION_SETTINGS_FLAGS_FAILURE,
    });

    if (error.isFetchingError) {
      dispatch(fetchingError());
      dispatch(errorNotification(error.message));
      return;
    }
    throw error;
  }
};

export const updateApplicationSettingsFlags = applicationSettingsFlags => async dispatch => {
  dispatch({
    type: UPDATE_APPLICATION_SETTINGS_FLAGS,
  });

  try {
    await updateApplicationSettingsFlagApi(applicationSettingsFlags);

    dispatch(successNotification('Application Settings flags updated'));
    return dispatch({
      type: UPDATE_APPLICATION_SETTINGS_FLAGS_SUCCESS,
      applicationSettingsFlags,
    });
  } catch (error) {
    dispatch({
      type: UPDATE_APPLICATION_SETTINGS_FLAGS_FAILURE,
    });

    if (error.isFetchingError) {
      dispatch(fetchingError());
      dispatch(errorNotification(error.message));
      return;
    }
    throw error;
  }
};

export const clearDevCache = () => async dispatch => {
  dispatch({
    type: CLEAR_DEV_CACHE,
  });

  try {
    await clearDevCacheApi();

    dispatch(successNotification('Api cache cleared'));
    dispatch({
      type: CLEAR_DEV_CACHE_SUCCESS,
    });
  } catch (error) {
    dispatch({
      type: CLEAR_DEV_CACHE_FAILURE,
    });

    if (error.isFetchingError) {
      dispatch(fetchingError());
      dispatch(errorNotification(error.message));
      return;
    }
    throw error;
  }
};

export const materializedViewRefresh = () => async dispatch => {
  dispatch({
    type: MATERIALIZED_VIEW_REFRESH,
  });

  try {
    await materializedViewRefreshApi();
    dispatch(successNotification('Materialized View Refresh started, please check after 10 minutes'));
    dispatch({
      type: MATERIALIZED_VIEW_REFRESH_SUCCESS,
    });
  } catch (error) {
    dispatch({
      type: MATERIALIZED_VIEW_REFRESH_FAILURE,
    });

    if (error.isFetchingError) {
      dispatch(fetchingError());
      dispatch(errorNotification(error.message));
      return;
    }
    throw error;
  }
};

export const unlockAllTaxEntries = () => async dispatch => {
  dispatch({
    type: UNLOCK_ALL_TAX_ENTRIES,
  });

  try {
    await unlockAllTaxEntriesApi();
    dispatch(successNotification('All tax entries have been unlocked.'));
    dispatch({
      type: UNLOCK_ALL_TAX_ENTRIES_SUCCESS,
    });
  } catch (error) {
    dispatch({
      type: UNLOCK_ALL_TAX_ENTRIES_FAILURE,
    });

    if (error.isFetchingError) {
      dispatch(fetchingError());
      dispatch(errorNotification(error.message));
      return;
    }
    throw error;
  }
};

export const fetchAdminJobs = () => async dispatch => {
  dispatch({ type: FETCH_ADMIN_JOBS });

  try {
    const adminJobs = await fetchAdminJobsApi();
    dispatch({
      type: FETCH_ADMIN_JOBS_SUCCESS,
      adminJobs,
    });
  } catch (error) {
    dispatch({
      type: FETCH_ADMIN_JOBS_FAILURE,
    });

    if (error.isFetchingError) {
      dispatch(fetchingError());
      dispatch(errorNotification(error.message));
      return;
    }

    throw error;
  }
};

export const runAdminJob = jobName => async dispatch => {
  dispatch({ type: RUN_ADMIN_JOB, jobName });
  try {
    dispatch(successNotification(`Running ${jobName} started. It make take a while.`));
    await runAdminJobApi(jobName);
    dispatch({ type: RUN_ADMIN_JOB_SUCCESS });
  } catch (error) {
    dispatch({ type: RUN_ADMIN_JOB_FAILURE });

    if (error.isFetchingError) {
      dispatch(fetchingError());
      dispatch(errorNotification(error.message));
      return;
    }

    throw error;
  }
};

export const runDeactivateUsersJob = () => async dispatch => {
  dispatch({ type: RUN_DEACTIVATE_USERS_JOB });
  try {
    dispatch(successNotification('Deactivate Users job started. It may take a while.'));
    const response = await runDeactivateUsersJobApi();
    dispatch({ type: RUN_DEACTIVATE_USERS_JOB_SUCCESS, jobId: response.jobId });
  } catch (error) {
    dispatch({ type: RUN_DEACTIVATE_USERS_JOB_FAILURE });

    if (error.isFetchingError) {
      dispatch(fetchingError());
      dispatch(errorNotification(error.message));
      return;
    }

    throw error;
  }
};

export const clearBsmBalances = (companyCode, periodName) => async dispatch => {
  dispatch({
    type: CLEAR_BSM_BALANCES,
  });

  try {
    await clearBsmBalancesApi(companyCode, periodName);
    dispatch(successNotification('BSM data has been cleared.'));
    dispatch({
      type: CLEAR_BSM_BALANCES_SUCCESS,
    });
  } catch (error) {
    dispatch({
      type: CLEAR_BSM_BALANCES_FAILURE,
    });

    if (error.isFetchingError) {
      dispatch(fetchingError());
      dispatch(errorNotification(error.message));
      return;
    }
    throw error;
  }
};

export const selectPeriods = periods => ({
  type: SELECT_PERIODS,
  selectedPeriods: periods,
});

export const selectCompanyCodes = companyCodes => ({
  type: SELECT_COMPANY_CODES,
  selectedCompanyCodes: companyCodes,
});
